import { type FC, lazy } from 'react'
import { DashRoute } from '../../../legacy/dash-components/dash-route/DashRoute'
import { DashSwitch } from '../../../legacy/dash-components/dash-switch/DashSwitch'
import { NoticeBannersAccessControl } from './access-control'

const NoticeBannersListPage = lazy(() =>
  import('./NoticeBannersListPage').then(m => ({ default: m.NoticeBannersListPage }))
)
const NoticeBannerEditorPage = lazy(() =>
  import('./NoticeBannerEditorPage').then(m => ({ default: m.NoticeBannerEditorPage }))
)

export const NoticeBannerRouter: FC = () => (
  <DashSwitch>
    <DashRoute
      exact
      route="admin-notice-banners"
      component={NoticeBannersListPage}
      accessControl={NoticeBannersAccessControl}
    />
    <DashRoute
      exact
      route="admin-notice-banners-new"
      component={NoticeBannerEditorPage}
      accessControl={NoticeBannersAccessControl}
    />
    <DashRoute
      exact
      route="admin-notice-banners-edit"
      component={NoticeBannerEditorPage}
      accessControl={NoticeBannersAccessControl}
    />
  </DashSwitch>
)
